import { Button, Card, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function Home() {
    const navigate = useNavigate();

    return (
        <Card>
            <Space direction="vertical" size={12}>
                <Title level={4} style={{ margin: 0 }}>
                    RAG Chatbot
                </Title>
                <Text type="secondary">
                    Ask questions from your indexed documents.
                </Text>
                <Button type="primary" onClick={() => navigate("/chat")}>
                    Open Chatbot
                </Button>
            </Space>
        </Card>
    );
}